import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

import { Storage } from '@capacitor/storage';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Router } from '@angular/router';


const LNG_KEY = 'SELECTED_SHOP_LANGUAGE';
@Injectable({
  providedIn: 'root'
})

export class LanguageService {
  selected: any;
  private languages = new BehaviorSubject<any[]>([
    { text: 'English', value: 'en', checked: false },
    { text: 'हिन्दी', value: 'hi', checked: false },
    { text: 'عربي', value: 'ar', checked: false },
    { text: 'Indonesian', value: 'id', checked: false },
    { text: '中国人', value: 'ch', checked: false },
  ]);

  constructor(private translate: TranslateService, private router: Router) {
    // store.create();
  }

  // set a key/value
  async set(key: string, value: any) {
    try {
      const result = await Storage.set({ key: key, value: value });
      return true;
    } catch (reason) {
      return false;
    }
  }
  // to get a key/value pair
  async get(key: string) {
    try {
      const { value } = await Storage.get({ key: key });
      if (value != null) {
        return value;
      }
      return null;
    } catch (reason) {
      return null;
    }
  }

  setInitialLang() {
    let lang = this.translate.getBrowserLang();
    this.translate.setDefaultLang(lang);
    this.selected = lang;
    this.get(LNG_KEY).then(value => {
      if (value != null) {
        this.setLang(value);
        this.selected = value;
      }
    }).catch(error => {
    });
  }

  async getOnBoarding() {
    return await this.get('appLanuch');
  }

  async removeName(key: string) {
    await Storage.remove({ key: key });
  };

  async clear() {
    await Storage.clear();
  }

  getLang() {
    return this.languages.asObservable();
  }

  getSelectedLang() {
    return this.selected;
  }

  async setLang(lng) {
    this.translate.use(lng);
    this.selected = lng;
    await this.set(LNG_KEY, lng);
  }
}
